import {
  REQUEST_ORDERS,
  CLEAR_ORDERS,
  SELECT_ORDER,
  SELECT_ALL_ORDERS,
  REQUEST_IDS_IN_PROGRESS,
  CANCEL_REQUEST_IDS_IN_PROGRESS,
  GENERATE_AVAILABILITY_REPORT
} from './actions';

export const defaultState = {
  orders: [],
  pageNumber: 1,
  totalRecords: 0,
  orderIdsSelectedMap: {},
  allOrdersSelected: false,
  selectAllClicked: false,
  requestingRemainingOrderIds: false
};

export const orderDetailsReport = (state = defaultState, action) => {
  switch (action.type) {
    case REQUEST_ORDERS:
      return {
        ...state,
        orders: state.orders.concat(...action.payload.orders),
        pageNumber: action.payload.pageNumber + 1,
        totalRecords: action.payload.totalRecords,
        orderIdsSelectedMap: action.payload.orders.reduce(
          (selectedObj, order) => ({
            ...selectedObj,
            [order.id]: state.selectAllClicked
          }),
          state.orderIdsSelectedMap
        )
      };
    case CLEAR_ORDERS:
      return defaultState;
    case SELECT_ORDER:
      return {
        ...state,
        orderIdsSelectedMap: {
          ...state.orderIdsSelectedMap,
          [action.payload.id]: action.payload.checked
        },
        allOrdersSelected: state.allOrdersSelected ? action.payload.checked : false
      };
    case SELECT_ALL_ORDERS:
      return {
        ...state,
        orderIdsSelectedMap: Object.keys(state.orderIdsSelectedMap).reduce(
          (selectedObj, orderId) => ({
            ...selectedObj,
            [orderId]: action.payload.checked
          }),
          {}
        ),
        allOrdersSelected: action.payload.checked,
        selectAllClicked: action.payload.checked
      };
    case REQUEST_IDS_IN_PROGRESS:
      return {
        ...state,
        requestingRemainingOrderIds: true
      };
    case CANCEL_REQUEST_IDS_IN_PROGRESS:
      return {
        ...state,
        requestingRemainingOrderIds: false
      };
    case GENERATE_AVAILABILITY_REPORT:
      return {
        ...state,
        requestingRemainingOrderIds: false
      };
    default:
      return state;
  }
};

export const orderDetailsReportSelectors = {
  orders: state => state.orderDetailsReport.orders,
  pageNumber: state => state.orderDetailsReport.pageNumber,
  totalRecords: state => state.orderDetailsReport.totalRecords,
  orderCount: state => state.orderDetailsReport.orders.length,
  orderIdsSelectedMap: state => state.orderDetailsReport.orderIdsSelectedMap,
  allOrdersSelected: state => state.orderDetailsReport.allOrdersSelected,
  selectAllClicked: state => state.orderDetailsReport.selectAllClicked,
  requestOrdersInProgress: state => state.requests.some(request => request.name === REQUEST_ORDERS && request.started),
  downloadInProgress: state =>
    state.orderDetailsReport.requestingRemainingOrderIds ||
    state.requests.some(request => request.name === GENERATE_AVAILABILITY_REPORT && request.started),
  downloadError: state => state.requests.some(request => request.name === GENERATE_AVAILABILITY_REPORT && request.error)
};
